const CREATE_SESSION = '[session][client]create.session'
const REMOVE_SESSION = '[session][client]remove.session'
const LOAD_SESSION = '[session][client]load.session'

export {CREATE_SESSION, REMOVE_SESSION, LOAD_SESSION}